export enum NonceType {
  NewAccountAndClient = 1,
  NewAccountForExistingClient = 2,
  ForgottenPassord = 3,
  ConfirmOrCancelAppointmentSms = 4,
  ConfirmOrCancelAppointmentEmail = 5,
  TelehealthInviteClient = 6,
  TelehealthClinicStaffAuthentication = 7,
  TelehealthClinicClientAuthentication = 8,
  SingleSignOn = 9,
  Survey = 10,
  BookingDetails = 11,
  TimeSlotNotification = 12,
  Unsubscribe = 13,
  ConfirmEmail = 14,
  ChangeEmailAddress = 15,
}
